
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../types/actionParams';
import { FlowDraftItem } from '../types/resourceParts';

export type GetFlowDraftResult = FlowDraftItem;

export class GetFlowDraftRequest extends Request<ISingleIdParams, GetFlowDraftResult> {
  constructor(params: ISingleIdParams) {
    super('getFlowDraft', params);
  }
}
